export default __webpack_public_path__ + "static/media/star_outlined.c1fc393b.svg";